import { render, staticRenderFns } from "./AdvancedView.vue?vue&type=template&id=0ddfc3f2&scoped=true&"
import script from "./AdvancedView.vue?vue&type=script&lang=js&"
export * from "./AdvancedView.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedView.vue?vue&type=style&index=0&id=0ddfc3f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddfc3f2",
  null
  
)

export default component.exports